"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE_RULES = void 0;
exports.getStateRules = getStateRules;
/**
 * Per-state accumulation rules, keyed by `Facility.state` (the two-letter
 * abbreviation). A state's rules replace the federal ones covering the same
 * limit — see `layerRules`. Anything a state doesn't cover keeps the federal
 * limit.
 *
 * Empty today: every facility resolves to federal limits regardless of
 * state. Adding a state means adding one array here; nothing else changes.
 * The numbers in a state's array are regulatory law, so each one needs to be
 * verified against that state's regulations before it's added.
 *
 * One thing this shape can't express yet: a state can replace a federal rule
 * but can't remove one. If a state has no satellite-area limits at all
 * (rather than different ones), leaving its satellite rules out means the
 * federal limits apply instead, which would be wrong. Adding a state like
 * that needs an explicit "no limit" marker first.
 */
exports.STATE_RULES = {};
function getStateRules(state) {
    if (state === null) {
        return [];
    }
    return exports.STATE_RULES[state] ?? [];
}
//# sourceMappingURL=state.js.map